(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.addresses = {
    attach: function(context, settings) {
      /**
       * 2022-11-22
       * Move validation for non-Latin (eg 夏洛特) characters from back-end to front-end
       *
       * Back end was unable to correct
       * so instead block submission until fields are corrected.
       */

      const validateAddressField = function($input, checkout = true) {
        jQuery('.address-validation-error').remove();
        let $submitButton;
        if (checkout) {
          $submitButton = jQuery('button[value="Continue to Payment"]');
        }
        else {
          $submitButton = jQuery('button[value="Save"].form-submit');
        }
        if ($submitButton.hasClass('submit-disabled-address-validation')) {
          $submitButton.removeClass('submit-disabled-address-validation');
          $submitButton.prop('disabled', false);
        }

        const regex = /[^a-zA-Z+0-9\s,.\-()#]/g;
        let m;

        let invalid = false;

        while ((m = regex.exec($input.val())) !== null) {
          // This is necessary to avoid infinite loops with zero-width matches
          if (m.index === regex.lastIndex) {
            regex.lastIndex++;
          }

          // The result can be accessed through the `m`-variable.
          m.forEach((match, groupIndex) => {
            console.log(`Found match, group ${groupIndex}: ${match}`);
            invalid = true;
          });
        }
        // Prevent form submission
        if (invalid) {
          const $error = jQuery(`
            <div data-drupal-messages="" class="address-validation-error">
              <div aria-label="Error message" class="messages messages--error">
                <div role="alert">
                  <h2 class="visually-hidden">Error message</h2>
                  This field contains invalid characters. Use only Latin letters, numbers, and punctuation (,.-()#). Please update the address and try again.
                </div>
              </div>
            </div>
          `);
          $input.closest('.form-item').before($error);
          jQuery([document.documentElement, document.body]).animate({
            scrollTop: ($input.offset().top - jQuery('.global-header').height() - 200)
          }, 1000);
          $input.addClass('error');
          $input.focus();
          $submitButton.addClass('submit-disabled-address-validation');
          $submitButton.prop('disabled', true);
        }
      };

      const $customerProfile = jQuery('#profile-customer-address-book-edit-form, #profile-customer-address-book-add-form');

      if ($customerProfile.length === 1) {
        $customerProfile.find('input').blur(function() { // JBB - 2025-02-05 - NOW9-1426 - removed .unbind() because it was breaking ajax calls
          const $input = jQuery(this);
          validateAddressField($input, false);
        });
      }

      const $shippingProfile = jQuery('#edit-shipping-address-profile');
      const $billingProfile = jQuery('#edit-billing-information-profile');

      if ($shippingProfile.length === 1) {
        $shippingProfile.find('input').blur(function() { // JBB - 2025-02-05 - NOW9-1426 - removed .unbind() because it was breaking ajax calls
          const $input = jQuery(this);
          validateAddressField($input);
        });
      }
      if ($billingProfile.length === 1) {
        $billingProfile.find('input').blur(function() { // JBB - 2025-02-05 - NOW9-1426 - removed .unbind() because it was breaking ajax calls
          const $input = jQuery(this);
          validateAddressField($input);
        });
      }
    }
  };
})(jQuery, Drupal);
